import { SxProps, Theme } from '@mui/material';

export const ConfirmCredentialsDialogContentSX: SxProps<Theme> = (theme) => ({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'fit-content',
	backgroundColor: 'white',
	borderRadius: '10px',
	boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
	[theme.breakpoints.down('sm')]: {
		width: '100%',
		top: '100%',
		transform: 'translate(-50%, -100%)',
		borderRadius: '0px',
		borderTopLeftRadius: '10px',
		borderTopRightRadius: '10px',
	},
});

export const ConfirmCredentialsDialogHeaderSX: SxProps<Theme> = {
	width: '100%',
	height: '40px',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '5px 0px 0px 0px',
};

export const ConfirmCredentialsDialogTitleSX: SxProps<Theme> = ({
	fontSize: {xs: 'var(--font-size-md)', sm: 'var(--font-size-lg)'},
	fontWeight: '800',
	letterSpacing: '0px',
	color: '#2C2C2C',
	opacity: 1,
});

export const ConfirmCredentialsDialogEmailSX: SxProps<Theme> = {
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'.MuiOutlinedInput-input': {
		padding: '14px 14px',
	},
};

export const ConfirmCredentialsDialogPasswordSX: SxProps<Theme> = {
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'.MuiOutlinedInput-input': {
		padding: '14px 14px',
	},
};

export const ConfirmCredentialsDialogCancelButtonSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-body)',
	width: '100%',
	borderRadius: '22px',
	paddingTop: '9px',
	paddingBottom: '9px',
	backgroundColor: '#F1F1F1',
	color: '#2C2C2C',
	height: '44px',
	fontWeight: '600',
});

export const ConfirmCredentialsDialogSubmitButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-body)',
	width: '100%',
	borderRadius: '22px',
	paddingTop: '9px',
	paddingBottom: '9px',
	backgroundColor: theme.palette.primary.main,
	color: 'white',
	height: '44px',
	fontWeight: '600',
});
